import { AxiosResponse } from 'axios';

import { HttpClient } from 'api/HttpClient';
import { ApplicationsFilters } from 'components/applications/applications.types';
import { ApplicationsStatusCategory, SortDirection } from 'components/applications/applications.enums';

import { BorrowerApplicationDto, GetApplicationsTableDto, UploadContractDto } from './applications.dto';

export class ApplicationApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/applications');
  }

  public async getApplicationById(applicationId: string) {
    return this.instance
      .get(`/${applicationId}`)
      .then((response: AxiosResponse<BorrowerApplicationDto>) => response.data);
  }

  public async sendIsNotMyCustomerMessage(applicationId: string) {
    return this.instance
      .post(`/${applicationId}/not-my-customer`)
      .then((response: AxiosResponse<any>) => response.data);
  }

  public async getApplications(filters: ApplicationsFilters) {
    const params = new URLSearchParams();

    params.append('offset', filters.offset.toString());
    params.append('count', filters.count.toString());
    params.append('search', filters.search || '');
    params.append('statusCategory', filters.statusCategory);

    if (filters.statusCategory === ApplicationsStatusCategory.Inactive && filters.inactiveStatus) {
      params.append('inactiveStatus', filters.inactiveStatus);
    }

    filters.sortByFields.forEach((sortByField) =>
      params.append(
        `sortByFields[${sortByField.sortField}]`,
        sortByField.isSortDesc ? SortDirection.Desc : SortDirection.Asc,
      ),
    );
    filters.sortByVariables.forEach((sortByVariable) =>
      params.append(
        `sortByVariables[${sortByVariable.sortField}]`,
        sortByVariable.isSortDesc ? SortDirection.Desc : SortDirection.Asc,
      ),
    );

    return await this.instance
      .get('/', { params: params })
      .then((response: AxiosResponse<GetApplicationsTableDto>) => response.data);
  }

  public async uploadContract(applicationId: string, files: File[]) {
    const formData = new FormData();

    formData.set('applicationId', applicationId);

    files.forEach((file) => {
      formData.append(`files`, file, file.name);
    });

    return await this.instance
      .post(`/${applicationId}/upload-contract`, formData)
      .then((response: AxiosResponse<UploadContractDto>) => response.data);
  }
}
